import { actionClient } from '@/api'
import store from '@/store'
export default {

  namespaced: true,

  state: {
    activityId: localStorage.getItem('activityId') || null,
    activity: JSON.parse(localStorage.getItem('activity') || 'null') || null,
  },


  mutations: {

    setActivity(state, { activityId, activity }) {
      state.activityId = activityId
      state.activity = activity
      if (activityId === null) {
        localStorage.removeItem('activityId')
      } else {
        //如果登陆的不是同一个活动则清除购物车数据
        // if(localStorage.getItem('activityId') != activityId){
        //     console.log('remove-cart')
        //     store.dispatch('cart/clear')
        // }
        localStorage.setItem('activityId', activityId)
      }

      if (activity === null) {
        localStorage.removeItem('activity')
      } else {
        localStorage.setItem('activity', JSON.stringify(activity))
      }
    },

  },

  actions: {
    async setId({ commit }, activityId) {
      try {
        const data = await actionClient.get('activity', {
          query: {activityId}
        })
        commit('setActivity', { activityId, activity: data })
        return data
      } catch (error) {
        commit('setActivity', { activityId: null, activity: null })
        throw error
      }
    }
  }


}
